// extracted by mini-css-extract-plugin
module.exports = {"experiment":"styles_experiment__c0t0C","text":"styles_text__j_4mm","img":"styles_img__Z62PQ"};